module.exports = __webpack_public_path__ + "static/atlaskit-table-context-menu-50ccf3801371f890a6e622f546943124.png";